import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { LoadPanel } from "devextreme-react";
import { onExportingEvent } from "../../../types/DevExtremeTypes";
import DataGrid, { Pager, Paging, Column, FilterPanel, Selection, Export } from "devextreme-react/data-grid";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import MatrixGridService from "../../../services/MatrixService";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";

interface MatchingBulkInviteGridProps extends WithTranslation {
    findMatchesClicked: boolean;
    pastedDetails: any[];
    updateFoundRecords: () => void;
    setSelectedRows: (selectedRows: any) => void;
    reloadMatchingGrid: boolean;
    userResponseData: any[];
    venueType: any[]
}

interface MatchingBulkInviteGridState {
    matchingDataSource: any[];
    loadPanelVisible: boolean;
    contactDetails: [];
    isSelectAllFlag: boolean;
}

//const MatchingBulkInviteGrid = React.memo(class extends Component<MatchingBulkInviteGridProps> {
class MatchingBulkInviteGrid extends Component<MatchingBulkInviteGridProps> {
    state: MatchingBulkInviteGridState;
    //venueHierarchyService: VenueHierarchyService;
    matrixGridService: MatrixGridService;
    dataGridRef: any;
    selectionRef: any;
    constructor(props: MatchingBulkInviteGridProps) {
        super(props);
        this.state = {
            matchingDataSource: [],
            loadPanelVisible: false,
            contactDetails: [],
            isSelectAllFlag: false,
        };
        this.matrixGridService = new MatrixGridService();
        this.dataGridRef = null;
        this.selectionRef = React.createRef();
        this.selectionRef.current = {
            checkBoxUpdating: false,
            selectAllCheckBox: null,
        };
    }

    componentDidMount() {
        this.fetchVenueDetails();
    }

    componentDidUpdate(prevProps: MatchingBulkInviteGridProps, prevState: MatchingBulkInviteGridState) {
        if (this.props.findMatchesClicked !== prevProps.findMatchesClicked && this.props.findMatchesClicked == true) {
            this.fetchVenueDetails();
        }
    }
    findVenueTypeId =(venueType:string)=>{
        if(venueType===""){
            return ""
        }else{
            let venueTypeId = this.props.venueType.find((item)=>item.value.toLowerCase() === venueType.toLowerCase())
            if(venueTypeId){
                return venueTypeId.id
            }else{
                return ""
            }
        }
    }
    transformVenues = (inputData: any[]): any[] => {
        return inputData.map((item): any => ({
            id: item.id,
            venueName: item.venueName,
            venueNameWOLocation: item.venueNameWOLocation,
            contact: {
                id: "",
                contactTypeLookUpId: "93",
                active: item.active.toLowerCase() === "yes" ? "True" : "False",
                contactTypeLookUp: {
                    id: "",
                    value: "",
                },
            },
            businessEntityId: item.businessEntityId,
            businessEntity: {
                id: "",
                shortName: item.businessEntity,
            },
            generalManager: {
                id: "",
                value: "",
            },
            organisationType: {
                id: "10",
                value: "",
            },
            organisationTypeId: "10",
            email: item.email,
            phone: item.phone,
            houseNumber: item.houseNumber,
            address: item.address,
            city: item.city,
            county: item.county,
            postCode: item.postCode,
            venueTypeId: this.findVenueTypeId(item.venueTypeId),
            venueType: {
                id: this.findVenueTypeId(item.venueTypeId),
                value: item.venueTypeId,
            },
            criticalVenueInfo: "",
            division: item.division,
            brand: item.brand,
            onboarded: item.onboarded.toLowerCase() === "yes" ? true : false,
            dynamicsContactID: "",
            contactId: "",
            lastUpdatedOn: "",
            lastUpdatedBy: "",
            user: {
                id: "",
                name: "",
                active: item.onboarded.toLowerCase() === "yes" ? "True" : "False",
                lastUpdatedOn: "",
                userRole: {
                    id: "",
                    value: "",
                    parentMappingId: "",
                },
            },
            website: item.website,
            contractCleaningBusinessEntity: {
                id: "",
                shortName: "",
            },
            securityProviderBusinessEntity: {
                id: "",
                shortName: "",
            },
            gardeningProviderBusinessEntity: {
                id: "",
                shortName: "",
            },
            windowProviderBusinessEntity: {
                id: "",
                shortName: "",
            },
            primaryCleaningContact: {
                id: "",
                name: "",
            },
            primarySecurityContact: {
                id: "",
                name: "",
            },
            primaryGardeningContact: {
                id: "",
                name: "",
            },
            primaryWindowContact: {
                id: "",
                name: "",
            },
        }));
    };
    fetchVenueDetails = () => {
        this.setState({
            loadPanelVisible: true,
        });
        let reqObj = this.props.pastedDetails;
        const transformedData = this.transformVenues(reqObj);
        this.matrixGridService
            .fetchVenueDetails(transformedData)
            .then(this.handleFetchContactSuccess)
            .catch(this.handleContactError);
    };

    hasErrorsForUsers = (filteredItem: any) => {
        let hasError = false;
        if (
            filteredItem &&
            !filteredItem.userRecord &&
            filteredItem.validationErrors &&
            filteredItem.validationErrors?.length > 0
        ) {
            hasError = true;
        }
        return hasError;
    };

    hasErrorsForUsers_createContacts = (filteredItem: any) => {
        let hasError = false;
        if (
            filteredItem &&
            !filteredItem.success &&
            filteredItem.validationErrors &&
            filteredItem.validationErrors?.length > 0
        ) {
            hasError = true;
        }
        return hasError;
    };

    handleFetchContactSuccess = (response: any) => {
        let contactData = response?.data?.data || [];
        let updatedPastedSource = this.props.pastedDetails;
        let newPastedSource: any[] = [];
        updatedPastedSource = newPastedSource;
        this.setState(
            {
                matchingDataSource: contactData, //set in state for grid updates and also send to parent for further updates
                //loadPanelVisible: false
            },
            () => {
                this.dataGridRef?.instance()?.clearSelection(); //previous if any
                this.setState({ isSelectAllFlag: true }, () => {
                    this.dataGridRef?.instance()?.selectAll();
                });
                this.props.updateFoundRecords();
            }
        );
    };

    handleContactError = (err: any) => {
        let matchedRecords: any[] = [];
        let updatedPastedSource = this.props.pastedDetails;
        this.setState(
            {
                loadPanelVisible: false,
                matchingDataSource: matchedRecords,
                errorMessage:
                    err.response && err.response.data && err.response.data.error
                        ? JSON.parse(JSON.stringify(err.response.data.error))
                        : null, // For capturing response at the time of exception and showing error message
            },
            () => {
                this.dataGridRef?.instance()?.clearSelection(); //previous if any
                this.props.updateFoundRecords();
            }
        );
    };

    onSelectionChanged = (e: SelectionChangedEvent) => {
        const deselectRowKeys: number[] = [];
        e.selectedRowsData.forEach((item: any) => {});
        if (deselectRowKeys.length) {
            e.component.deselectRows(deselectRowKeys);
        }
        this.selectionRef.current.checkBoxUpdating = true;
        const selectAllCheckBox = this.selectionRef.current.selectAllCheckBox;
        selectAllCheckBox?.option("value", this.isSelectAll(e.component));
        this.selectionRef.current.checkBoxUpdating = false;

        let selectedRows = e.selectedRowsData;
        if (this.state.isSelectAllFlag) {
            this.setState({ isSelectAllFlag: false, loadPanelVisible: false });
        }

        this.props.setSelectedRows ? this.props.setSelectedRows(selectedRows) : null;
    };

    isSelectAll = (dataGrid: any) => {
        let items: any[] = [];
        dataGrid
            .getDataSource()
            .store()
            .load()
            .then((data: any) => {
                items = data;
            });
        let selectableItems = [];
        selectableItems = items.filter((a) => this.isSelectableForDuplicates(a));

        let selectedRowKeys = dataGrid.option("selectedRowKeys");
        if (!selectedRowKeys || !selectedRowKeys.length) {
            return false;
        }
        return selectedRowKeys.length >= selectableItems.length ? true : undefined;
    };

    isSelectableForDuplicates = (item: any) => {
        let selectable = false;
        // let navigateFrom = this.props.navigateFrom || '';
        // if (navigateFrom == BULK_FLOW.BULK_CREATE_CONTACTS && item && !item.emailMatched && item.providerId && item.contactType) {
        //     selectable = true;
        // }
        return selectable;
    };

    onEditorPreparing = (e: any) => {
        let dataGrid = e.component;
        if (e.type !== "selection") return;
        if (e.parentType === "headerRow") {
            e.editorOptions.onInitialized = (e: any) => {
                if (e.component) this.selectionRef.current.selectAllCheckBox = e.component;
            };
            e.editorOptions.value = this.isSelectAll(dataGrid);
            e.editorOptions.onValueChanged = (e: any) => {
                if (!e.event) {
                    if (e.previousValue && this.selectionRef.current.checkBoxUpdating)
                        e.component.option("value", e.previousValue);
                    return;
                }
                if (this.isSelectAll(dataGrid) === e.value) return;
                e.value ? dataGrid.selectAll() : dataGrid.deselectAll();
                e.event.preventDefault();
            };
        }
    };

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    };

    colorStatusForEntity = (cellInfo: any, type: string) => {
        let itemMatched = cellInfo?.data?.data?.itemMatched;
        let emailMatched = cellInfo?.data?.data?.emailMatched;
        let providerMatched = cellInfo?.data?.data?.providerMatched;
        let provider = cellInfo?.data?.data?.provider_fromAPI || "";
        let providerId = cellInfo?.data?.data?.providerId_fromAPI || "";

        if (itemMatched) {
            return (
                <>
                    <div className="new-email color-change">
                        <div>{`${type == "name" ? provider : providerId}`}</div>
                    </div>
                </>
            );
        } else if (emailMatched && !providerMatched) {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "red", padding: "0.5rem" }}>
                        <div>{`${type == "name" ? provider : providerId}`}</div>
                    </div>
                </>
            );
        }
        return <div style={{ padding: "0.5rem" }}></div>;
    };

    providerIdFoundCellValue = (cellInfo: any) => {
        let providerId = cellInfo?.providerId_fromAPI || "";
        return providerId;
    };

    providerFoundCellValue = (cellInfo: any) => {
        let provider = cellInfo?.provider_fromAPI || "";
        return provider;
    };

    colorStatusOfResult = (cellInfo: any) => {
        let found = cellInfo?.data?.data?.found;

        if (found === "Venue Found") {
            return (
                <>
                    <div className="color-change">
                        <div>{found}</div>
                    </div>
                </>
            );
        } else if (found === "New Venue") {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "#f7b500", padding: "0.5rem" }}>
                        <div>{found}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "red", padding: "0.5rem" }}>
                        <div>{found}</div>
                    </div>
                </>
            );
        }
    };
    colorStatusOfId = (cellInfo: any) => {
        let found = cellInfo?.data?.data?.found;
        if (found === "Venue Found") {
            return (
                <>
                    <div>
                        <div>{cellInfo?.data?.data?.id}</div>
                    </div>
                </>
            );
        } else if (found === "Venue Not Found") {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "red", padding: "0.5rem" }}>
                        <div>{cellInfo?.data?.data?.id}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div>
                        <div>{""}</div>
                    </div>
                </>
            );
        }
    };
    colorStatusOfClient = (cellInfo: any, value: any) => {
        let found = cellInfo?.data?.data?.found;

        if (found === "Venue Found") {
            return (
                <>
                    <div>
                        <div>{value}</div>
                    </div>
                </>
            );
        } else if (found === "Duplicate Venue") {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "red", padding: "0.5rem" }}>
                        <div>{value}</div>
                    </div>
                </>
            );
        } else if (found === "New Venue") {
            return (
                <>
                    <div className="color-change">
                        <div>{value}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div>
                        <div>{""}</div>
                    </div>
                </>
            );
        }
    };
    colorStatusOfHouseNumber = (cellInfo: any) => {
        let found = cellInfo?.data?.data?.found;

        if (found === "Venue Not Found") {
            return (
                <>
                    <div>
                        <div>{""}</div>
                    </div>
                </>
            );
        } else if (found === "Duplicate Venue") {
            return (
                <>
                    <div style={{ fontWeight: "bold", color: "red", padding: "0.5rem" }}>
                        <div>{cellInfo?.data?.data?.id}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div>
                        <div>{cellInfo?.data?.data?.houseNumber}</div>
                    </div>
                </>
            );
        }
    };
    colorStatus = (cellInfo: any, value: any) => {
        let found = cellInfo?.data?.data?.found;

        if (found === "Venue Not Found" || found === "Duplicate Venue") {
            return (
                <>
                    <div>
                        <div>{""}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="color-change">
                        <div>{value}</div>
                    </div>
                </>
            );
        }
    };
    colorStatusOfOnboarded = (cellInfo: any, value: any) => {
        let found = cellInfo?.data?.data?.found;
        let onboarded = value ? "Yes" : "No";
        if (found === "Venue Not Found" || found === "Duplicate Venue") {
            return (
                <>
                    <div>
                        <div>{""}</div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="color-change">
                        <div>{onboarded}</div>
                    </div>
                </>
            );
        }
    };

    render() {
        return (
            <div>
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                <div className="row">
                    <div className="col-md">
                        <DataGrid
                            dataSource={this.state.matchingDataSource}
                            showBorders={false}
                            showColumnLines={false}
                            allowColumnReordering={true}
                            columnAutoWidth={true}
                            columnResizingMode={"widget"}
                            allowColumnResizing={true}
                            onSelectionChanged={this.onSelectionChanged}
                            ref={(ref) => {
                                this.dataGridRef = ref;
                            }}
                            remoteOperations={false}
                            onExporting={this.onExporting}
                        >
                            <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always"></Selection>
                            <FilterPanel visible={true} />
                            <Paging defaultPageSize={10} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                            <Export enabled={true} />
                            <Column
                                dataField="found"
                                caption="RESULT"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfResult(cellInfo);
                                }}
                            />
                            <Column
                                dataField="id"
                                caption="ID"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfId(cellInfo);
                                }}
                            />
                            <Column
                                dataField="businessEntity"
                                caption="CLIENT"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfClient(
                                        cellInfo,
                                        cellInfo?.data?.data?.businessEntity.shortName
                                    );
                                }}
                            />
                            <Column
                                dataField="businessEntityId"
                                caption="CLIENT ID"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfClient(cellInfo, cellInfo?.data?.data?.businessEntityId);
                                }}
                            />
                            <Column
                                dataField="houseNumber"
                                caption="HOUSE NUMBER"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfHouseNumber(cellInfo);
                                }}
                            />
                            <Column
                                dataField="venueName"
                                caption="VENUE NAME"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.venueName);
                                }}
                            />
                            <Column
                                dataField="address"
                                caption="ADDRESS"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.address);
                                }}
                            />
                            <Column
                                dataField="city"
                                caption="TOWN/CITY"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.city);
                                }}
                            />
                            <Column
                                dataField="county"
                                caption="COUNTY"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.county);
                                }}
                            />
                            <Column
                                dataField="postCode"
                                caption="POSTCODE"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.postCode);
                                }}
                            />
                            <Column
                                dataField="phone"
                                caption="PHONE"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.phone);
                                }}
                            />
                            <Column
                                dataField="email"
                                caption="EMAIL"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.email);
                                }}
                            />
                            <Column
                                dataField="brand"
                                caption="BRAND"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.brand);
                                }}
                            />
                            <Column
                                dataField="division"
                                caption="DIVISION"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.division);
                                }}
                            />
                            <Column
                                dataField="website"
                                caption="WEBSITE"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.website);
                                }}
                            />
                            <Column
                                dataField="venueNameWOLocation"
                                caption="VENUE NAME WO LOCATION"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.venueNameWOLocation);
                                }}
                            />
                            <Column
                                dataField="venueTypeId"
                                caption="VENUE TYPE"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatus(cellInfo, cellInfo?.data?.data?.venueType?.value);
                                }}
                            />
                            <Column
                                dataField="onboarded"
                                caption="ONBOARDED"
                                cellComponent={(cellInfo: any) => {
                                    return this.colorStatusOfOnboarded(cellInfo, cellInfo?.data?.data?.onboarded);
                                }}
                            />
                            <Column dataField="contactId" caption="CONTACT ID" />
                            <Column dataField="lastUpdatedBy" caption="LAST UPDATED BY" />
                            <Column dataField="lastUpdatedOn" caption="LAST UPDATED ON" />
                        </DataGrid>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(MatchingBulkInviteGrid);
